module.exports = __webpack_public_path__ + "img/hands-helping-solid.2e51847.svg";